import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function generateStory(data: FormData): string {
  return `# ${data.title || ''}

Date: ${data.date || ''}
Location: ${data.location || ''}
Department: ${data.department || ''}

## Purpose/Objective
${data.objective || ''}

## Key Participants
${data.participants || ''}

## Event Description
${data.description || ''}

## Challenges and Highlights
${data.challenges || ''}

## Outcomes and Results
${data.outcomes || ''}

${data.quotes ? `## Quotes and Testimonials\n${data.quotes}` : ''}

## Key Takeaways
${data.takeaways || ''}`;
}